module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAfklEQVQ4y2NgGBTAsfPuf3Iw7Q1ImPP4f/K8x+QbMPfQWzAmyYDw6Q//py98AsYP3vwEYxgfJEfQgMDJD/6fvPf1PzoAiYHkiPbCvuuf4ZpBbJLD4PqzH/+fffgNxiA2SQaA/Aqy1av/PhiD2Oj+x2uAR++9/8SIUS8hDW0AAGdHr/FjIYj5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SO.png
// module id = 1267
// module chunks = 0